
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class Icon extends Vue {
  @Prop() size!: string;
  @Prop() image!: string;
}
export default Icon;
